/**
 * Drag Select Plugin for uPlot (X-axis only)
 * Implements rectangle selection for zooming
 */

import uPlot from "uplot";

export function dragSelectPlugin() {
  return {
    hooks: {
      setSelect: [
        (u: uPlot) => {
          const sel = u.select;

          // Skip if selection is cleared or too small
          if (sel.width < 10) {
            return;
          }

          const newXMin = u.posToVal(sel.left, "x");
          const newXMax = u.posToVal(sel.left + sel.width, "x");

          // Clear selection
          u.setSelect({ left: 0, top: 0, width: 0, height: 0 }, false);

          // Apply zoom asynchronously
          setTimeout(() => {
            u.setScale("x", { min: newXMin, max: newXMax });
          }, 0);
        },
      ],
    },
  };
}
